import { render } from "./v-dropdown.vue?vue&type=template&id=5f6d87cf"
import script from "./v-dropdown.vue?vue&type=script&lang=js"
export * from "./v-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__